<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="intro"> </p>
<p class="CT"><span class="ePub-B">INTRODUCTION</span></p>
<p class="sp1"> </p>
<p class="CO">It was winter 2002 in Washington, D.C., many years after the bloodbath. How many had died so prematurely? Sixty people? Eighty? The estimates varied. Some people had just vanished without a trace, making the count difficult.</p>
<p class="TX">Most players were off the field now. Their names had already appeared in the “Irish sporting pages”—that is, the obituaries. The McLaughlins, Bernie and Punchy, were memories, so were all three Bennetts, and Jimmy the Bear, the craziest of them all—as well as Buddy McLean, the toughest, perhaps. The top Mafiosi were long gone, or in jail: Raymond Patriarca, Larry Baione, Jerry Angiulo, and others.</p>
<p class="TX">And there, before a largely impotent congressional panel, stood the ancient gnomelike FBI agent, H. Paul Rico. His hair was silver, his skin tanned from the Florida sun. His sickening heart was rapidly making him a ghost, and he had many secrets to take with him. On that winter day in Washington, there was blood in the water, old and bad—and the representatives wanted to hand the public a victim. The congressmen even had feared Rico would go the usual route of gangsters, and take the Fifth. But he didn’t.</p>
<p class="TX">Then the assembled representatives ineptly tried to force the ancient lawman to incriminate himself. But the ever-canny Rico couched all his answers to take any responsibility away from himself or the sacred bureau. That was how the system worked. To be fair, Rico did what the public, the president, and the FBI had asked him to do. The bureau was central in all this, surviving everything. But Rico’s former Department of Justice bosses, J. Edgar Hoover and Robert Kennedy, were already ghosts—and tarnished ones, at that. Yet, so was their onetime enemy, the Mafia.</p>
<p class="TX">So on this day, even a mere U.S. congressman could dare throw accusations at an FBI special agent. The congressman even bemoaned the fate of a small-time crook, Joseph “the Horse” Salvati. Rico’s efforts meant that Salvati had done a lot of time for a matter that, at most, he’d only been slightly connected to.</p>
<p class="TX">“You don’t care,” the congressman charged Rico. “Does it bother you that this man was in jail for thirty years?”</p>
<p class="TX">“It would probably be a nice movie or something,” Rico responded.</p>
<p class="TX">The congressman eventually asked: “Do you have any remorse?”</p>
<p class="TX">“Remorse for what?”</p>
<p class="TX">“For the fact that you played a role in this.”</p>
<p class="TX">“I believe the role I played was the role I should have played.… That’s it. I cannot—”</p>
<p class="TX">“So you don’t really care much and you don’t really have any remorse. Is that true?”</p>
<p class="TX">Rico sneered. “Would you like tears or something?”</p>
<p class="TX">“Pardon me?”</p>
<p class="TX">“What do you want, tears?”</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// introduction.vue?7023bd2c